module.exports = __webpack_public_path__ + "static/img/tips.3c3c5a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/tips.png
// module id = rqC4
// module chunks = 1